import {profGralSpac} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useLoadProfGralSpac() {
  return useLoad(profGralSpac, ['iD_ProfGral', 'iD_ProfileSpac'], {});
}

export default useLoadProfGralSpac;
